const Screens = {
  CONTACT_FORM:         'contact',
  APPT_LOCATION:   'location',
  APPT_CALENDAR:   'schedule',
  APPT_SUCCESS:    'successful',
  APPT_FAIL:       'failed',
};

function pruneObj(input = {}) {
  const output = {...input};
  delete output[''];
  return output;
}

const igniteLocation = {
  lat: 32.948809, lng: -96.805041 //Ignite Sales Office
};

export { Screens, pruneObj, igniteLocation };
